module.exports = __webpack_public_path__ + "static/media/features_timesheet.8d5406e2.png";